import { Validators } from '@angular/forms';

export class NewPasswordForm {
	password = ['', [Validators.required, Validators.minLength(8)]];
	confirmPassword = ['', Validators.required];
}
